import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';



import Map, { Marker, Popup } from "react-map-gl/mapbox";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './styles.css';

import chevron from '../../../assets/chevron_pin.png'
import { Store } from '../../store/Store';

import { toLatLng, toViewState } from "../../../utils/geo";





// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker';
mapboxgl.workerClass = MapboxWorker

const MAPBOX_TOKEN = 'pk.eyJ1IjoiY25vdGV6dyIsImEiOiJjbGwyNHlzYW8wNDU1M3Bxc3RjNWliZmN1In0.JuNYprf-c08-veQTcQXluA';

const drawerWidth = '100%';

export function MapView({ open, providers, ipInfo }) {
  const { state: { serviceProvider } } = useContext(Store);

  const [popupInfo, setPopupInfo] = React.useState(null);
  const [providerPins, setPins] = React.useState([]);
  // Listings store `coordinates` as an object; older rows stored an array.
  // toViewState reads either, and yields null when there is no position.
  const [coordinates, setCoordinates] = React.useState(() => toViewState(ipInfo, 10));

  // Depends on `providers` only. The `info` argument this used to take was
  // read by the commented-out <LocationOnIcon> below and nothing else.
  const pins = React.useCallback(() =>
    providers.map((city, index) => {
      const point = toLatLng(city);
      // A listing with no usable position is skipped, not pinned at NaN.
      if (!point) return null;
      return (
        <Marker
          key={`marker-${city.name}-${city.description}`}
          longitude={point.longitude}
          latitude={point.latitude}
          anchor="bottom"
          onClick={e => {
            e.originalEvent.stopPropagation();
            setPopupInfo(city);
          }}
        >
          <img src={chevron} alt="" style={{ width: '2.5rem' }} />
        </Marker>
      )
    }), [providers])

  // providers
  React.useEffect(() => {
    if (serviceProvider) {

      const view = toViewState(serviceProvider, 13.5)
      if (view) setCoordinates(view)
      setPopupInfo(serviceProvider)
    }
  }, [serviceProvider]);

  React.useEffect(() => {
    setPins(pins())
  }, [pins])

  return (
    <Box
      sx={{
        width: drawerWidth,
        height: '100%',
        overflow: 'hidden',
        flexShrink: 0,
        position: "relative"
      }}
    >
      {coordinates &&
        <Map
          {...coordinates}
          onMove={evt => setCoordinates(evt.viewState)}
          style={{ width: drawerWidth, height: "100%" }}
          mapStyle="mapbox://styles/mapbox/streets-v12"
          mapboxAccessToken={MAPBOX_TOKEN}
        >
          {/* <Marker longitude={ipInfo.coordinates[1]} latitude={ipInfo.coordinates[0]}>
          <img src={chevron} style={{width: '3rem'}}/>
        </Marker> */}
          {providerPins}

          {popupInfo && toLatLng(popupInfo) && (
            <Popup
              anchor="top"
              longitude={toLatLng(popupInfo).longitude}
              latitude={toLatLng(popupInfo).latitude}
              onClose={() => setPopupInfo(null)}
              style={{ background: 'transparent' }}
            >
              <Card sx={{ maxWidth: 345, borderRadius: 3, cursor: 'pointer', margin: 0, padding: 0, width: '240px' }}>
                <CardHeader
                  title={popupInfo.name}
                  subheader={popupInfo.location}
                />
                <CardMedia
                  component="img"
                  height="100%"
                  width='100%'
                  image={popupInfo.images?.[0] || ''}
                  alt={popupInfo.name}
                />
              </Card>
            </Popup>
          )}
        </Map>}

    </Box>
  );
}
